module.exports = __webpack_public_path__ + "img/resources-webinars.c4a2963f.png";